import { createSlice } from '@reduxjs/toolkit';

const productSlice = createSlice({
  name: 'product',
  initialState: {
    products: [],
    productTypes: [],
    productTypeLinks: [],
  },
  reducers: {
    setProductData(state, action) {
      const { products, productTypes, productTypeLinks } = action.payload;
      if (products) state.products = products;
      if (productTypes) state.productTypes = productTypes;
      if (productTypeLinks) state.productTypeLinks = productTypeLinks;
    },
    updateProduct(state, action) {
      const idx = state.products.findIndex(p => p.id === action.payload.id);
      if (idx >= 0) state.products[idx] = { ...state.products[idx], ...action.payload };
    },
    addProductType(state, action) {
      state.productTypes.push(action.payload);
    },
    updateProductType(state, action) {
      const idx = state.productTypes.findIndex(t => t.id === action.payload.id);
      if (idx >= 0) state.productTypes[idx] = { ...state.productTypes[idx], ...action.payload };
    },
    removeProductType(state, action) {
      state.productTypes = state.productTypes.filter(t => t.id !== action.payload);
      state.productTypeLinks = state.productTypeLinks.filter(l => l.typeId !== action.payload);
    },
    toggleTypeLink(state, action) {
      const { productId, typeId } = action.payload;
      const idx = state.productTypeLinks.findIndex(l => l.productId === productId && l.typeId === typeId);
      if (idx >= 0) {
        state.productTypeLinks[idx].linked = !state.productTypeLinks[idx].linked;
      } else {
        const type = state.productTypes.find(t => t.id === typeId);
        const defaultConfig = {};
        (type?.allowedDenominations || []).forEach(d => { defaultConfig[d] = 0; });
        state.productTypeLinks.push({ productId, typeId, linked: true, winnerConfig: defaultConfig });
      }
    },
    updateLinkWinnerConfig(state, action) {
      const { productId, typeId, winnerConfig } = action.payload;
      const idx = state.productTypeLinks.findIndex(l => l.productId === productId && l.typeId === typeId);
      if (idx >= 0) {
        state.productTypeLinks[idx].winnerConfig = winnerConfig;
      }
    },
  },
});

export const { setProductData, updateProduct, addProductType, updateProductType, removeProductType, toggleTypeLink, updateLinkWinnerConfig } = productSlice.actions;
export default productSlice.reducer;
